import React, { useState, useEffect } from "react";
import { useSearchQuery, usePagination } from "../../../hooks";
import { VTypeForm } from "./form";
import { MPSharedTable, MPSharedDeleteModal, MPSharedHeader } from "../Shared";
import { useGetVTypesQuery, useDeleteVTypeMutation } from "../services";
import { useDelete } from "../../../hooks";
import { getLocalizedString } from "../../../shared/translation";

export const VTypesContainer = () => {
  const { page, setPage, perPage, pagination } = usePagination();

  const { setSimpleSearch, setAdvanceSearch, q } = useSearchQuery({
    page,
    setPage,
    simpleSearchKey: "name_cont",
  });

  const {
    data = { data: [], total_count: 0 },
    error,
    isFetching,
    isSuccess,
  } = useGetVTypesQuery({
    page,
    per_page: perPage,
    order_by: "vehicle_types.created_at",
    order_dir: "desc",
    q,
  });

  const {
    deleteItem: deleteVType,
    deleteErrorMsg,
    setDeleteErrorMsg,
  } = useDelete({
    deleteMutation: useDeleteVTypeMutation,
    closeModal: () => setShowDeleteWarning(false),
  });

  const [showDeleteWarning, setShowDeleteWarning] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const [idToDelete, setIdToDelete] = useState(null);
  const [idToEdit, setIdToEdit] = useState(null);

  const onEdit = (data) => {
    setShowForm(true);
    setIdToEdit(data.id);
  };

  const onDelete = (data) => {
    setShowDeleteWarning(true);
    setIdToDelete(data.id);
  };

  const onCreate = () => {
    setShowForm(true);
    setIdToEdit(null);
  };

  const headers = [
    {
      label: getLocalizedString("name", "Name"),
      key: "name",
      className: "name",
    },
    {
      label: getLocalizedString("added_on", "Added On"),
      key: "created_at",
      className: "date",
    },
  ];

  const getDeleteItemName = (id) => {
    let name = "";
    const index = data?.data?.findIndex((item) => item.id === id);
    if (index >= 0) {
      name = data?.data[index]?.name;
    }
    return name;
  };

  return (
    <>
      <article className="main-container">
        <MPSharedHeader
          groupName="vehicle"
          createNewHandler={onCreate}
          resourceName="Vehicle Types"
          heading={getLocalizedString("vehicles", "Vehicles")}
          handleSearchKey={setSimpleSearch}
          simpleSearchPlaceholder={getLocalizedString("search_by_name", "Search by Name")}
        />

        <MPSharedTable
          resourceName="Vehicle Types"
          data={data?.data || []}
          error={error}
          isLoading={isFetching}
          isSuccess={isSuccess}
          headers={headers}
          onEdit={onEdit}
          onDelete={onDelete}
          pagination={{ ...pagination, count: data.total_count }}
          className="vehicle-types"
          auditResource="VehicleType"
          auditKey="name"
        />
      </article>

      <MPSharedDeleteModal
        show={showDeleteWarning}
        entityName={getLocalizedString("vehicle_type", "Vehicle type")}
        error={deleteErrorMsg}
        onHide={() => {
          setDeleteErrorMsg("");
          setShowDeleteWarning(false);
        }}
        itemName={getDeleteItemName(idToDelete)}
        onDelete={() => deleteVType({ id: idToDelete })}
      />

      {showForm && <VTypeForm idToEdit={idToEdit} onClose={setShowForm} />}
    </>
  );
};
